import React from 'react';

function HomePage() {
    return (
        <div>
            <h1>Hallo,</h1>
            <p>ich bin Zimmerermeister aus Leipzig.</p>
            <p>Ich mag alte Eichenbalken und traditionell verzapftes Fachwerk.</p>
            <p>Ich mag auch neue Ideen zum effizienten und nachhaltigen Bauen.</p>
            <p>Ich arbeite genau so gern mit Sägen und Hobeln direkt am Holz wie mit Maus und Tastatur im Planungsprogramm</p>
        </div>
    );
}

export default HomePage;